/*=============================================
|                 IMPORTS                     |
=============================================*/
import Vue from 'vue'
import App from './App.vue'
import 'leaflet/dist/leaflet.css';
import VueEasyLightbox from 'vue-easy-lightbox'

import Vuelidate from 'vuelidate'

/*=============================================
|            INITIALIZE FILES                 |
=============================================*/
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'
import              './plugins/axios'

/*=============================================
|                INSTANCES                    |
=============================================*/
Vue.use(Vuelidate)
Vue.use(VueEasyLightbox)

//Globally
Vue.prototype.$brand        = 'Kuroda'
//Vue.prototype.$hostImages = 'http://localhost:3332'
//Vue.prototype.$hostImages = 'https://rastreobdes.kuroda.com'
Vue.prototype.$hostImages = 'https://rastreob.kuroda.com'
Vue.config.productionTip = false
Vue.config.performance   = true;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
